import { render, staticRenderFns } from "./RecipeList.vue?vue&type=template&id=238eb0b3&scoped=true"
import script from "./RecipeList.vue?vue&type=script&lang=js"
export * from "./RecipeList.vue?vue&type=script&lang=js"
import style0 from "./RecipeList.vue?vue&type=style&index=0&id=238eb0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238eb0b3",
  null
  
)

export default component.exports